module.exports = __webpack_public_path__ + "career-icon-dental.3AUXbeCr.svg";